import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import TermAndCondition from "./footerSection/TermAndCondition";
import RefundPolicy from "./footerSection/RefundPolicy";
import TermOfUse from './footerSection/TermOfUse'
import RedeemRewards from "./pages/RedeemRewards";
import RedeemProduct from "./pages/RedeemProduct";
import RedeemMyGiftCards from "./pages/RedeemMyGiftCards";
import RewardsCongratulation from "./pages/RewardsCongratulation";
import Login from "./components/ExpertQuestionAnswer/Login";
import Questions from "./components/ExpertQuestionAnswer/Questions";
import OpiGoPage from "./components/EtNow/OpiGoPage";

function App() {
  return (
    <div className="App">
      {/* <BrowserRouter>
        <Routes>
          <Route path="/" element={<OpiGoPage />} />
          <Route path="/term&conditions" element={<TermAndCondition/>} />
          <Route path="/termOfUse" element={<TermOfUse/>} />
          <Route path="/refundPolicy" element={<RefundPolicy/>} />
          <Route path="/redeem-rewards" element={<RedeemRewards/>} />
          <Route path="/redeem-rewards/product" element={<RedeemProduct/>} />
          <Route path="/redeem-rewards/my-gift-card" element={<RedeemMyGiftCards/>} />
          <Route path="/redeem-rewards/product/congratulation" element={<RewardsCongratulation/>} />

        </Routes>
      </BrowserRouter>  */}

      <BrowserRouter> 
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/login" element={<Login/>} />
          <Route path="/questions" element={<Questions/>} />

        </Routes>
      </BrowserRouter>

      {/* <Login /> */}

      {/* <Questions /> */}

    </div>
  );
}

export default App;
